// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyBwyCj2BBc3YTf19E0S7nb3lHhzCWC-Hgw",
    authDomain: "ccentral-9b051.firebaseapp.com",
    databaseURL: "https://ccentral-9b051.firebaseio.com",
    projectId: "ccentral-9b051",
    storageBucket: "ccentral-9b051.appspot.com",
    messagingSenderId: "364932237666",
    appId: "1:364932237666:web:29ca889c18711c3a33443b",
    measurementId: "G-JXS1DKCSS6"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
